import React, {Component, useEffect, useState} from 'react'
import { Link } from 'react-router-dom'
import history from "../../../route/history";
import {alertActions, regisActions, loaderActions, inboxActions} from "../../../store/actions";
import {connect} from "react-redux";

const PdfViewer = props => {

  const [message, setMessage] = useState("파일 조회 중입니다.");

  useEffect(() => {
    if (!props.match.params.fileId) return;

    props.getPdfString(props.match.params.fileId);

  }, [props.match.params.fileId])

  //PDF base64 호출
  useEffect(() => {
    if (!props.pdfString || props.pdfString?.length <= 0) {
      return;
    }

    let pdfWindow = window.open("", '_self');
    pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64," + props.pdfString + "'></iframe>")

  }, [props.pdfString]);

  useEffect(() => {
    if (props.isFailure === true && props.isLoading === false) {
      setMessage("파일 조회에 실패하였습니다.");
    }

  }, [props.isFailure])

  return (
      <React.Fragment>
        {window?.seq ? message : ''}
      </React.Fragment>
  )
}

const mapStateToProps = state => {
  return {
    pdfString: state.inbox?.pdfString,
    isLoading: state.inbox.isLoading,
    isFailure: state.inbox.isFailure,
  }
}

const actionCreators = {
  getPdfString: inboxActions.getPdfString,
}

export default connect(
    mapStateToProps,
    actionCreators
)(PdfViewer)
